/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForMicrosoftTeams extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForMicrosoftTeams");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForMicrosoftTeams.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForMicrosoftTeams>): ServiceAccountCredentialsForMicrosoftTeams {
        let obj = Object.assign(new ServiceAccountCredentialsForMicrosoftTeams(), model);
        ServiceAccountCredentialsForMicrosoftTeams.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForMicrosoftTeams>): ServiceAccountCredentialsForMicrosoftTeams {
        if (!model) return null;
        return ServiceAccountCredentialsForMicrosoftTeams.newInstance(<ServiceAccountCredentialsForMicrosoftTeams> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForMicrosoftTeams) {
        if (!obj) return;

        models.ServiceAccountCredentialsForMicrosoftTeams.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForMicrosoftTeams): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForMicrosoftTeams.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id. This is a required field.
     */
    tenant_id: string;

    /**
     * Application Id. This is a required field.
     */
    application_id: string;

    /**
     * Application Secret. This is a required field.
     */
    application_secret: string;

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

    /**
     * Group Id. This is a required field.
     */
    group_id: string;

}
